import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { APIChangeMyCompany } from '../api/user/User';
import { Menu } from '@headlessui/react';
import {CompanyBadge} from "#src/helper/userHelper";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

export const ChangeCompany = () => {
  const { user } = useContext(UserContext);
  const companies = user.myCompanies

  const handleChange = async (companyId) => {
      await APIChangeMyCompany(user.id, companyId);
      // reload page
      window.location.href = "/";
  };

  const isCurrentCompany = (companyId) => {
    return user.companyId === companyId;
  }

  return (
    <Menu as="div" className="relative text-sm inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full items-center justify-center rounded-md overflow-hidden text-sm text-gray-600 justify-items-center hover:bg-gray-50 ">
          { user.myCompanies ? CompanyBadge(user.myCompanies?.find(company => company.target_id === user.companyId)?.company_name, 8, 'xs', true) : ''}
        </Menu.Button>
      </div>

      <Menu.Items
        transition="true"
        className="absolute left-10 bottom-10 overflow-hidden z-10 mt-2 w-[250px]  origin-bottom-left divide-y divide-gray-500 rounded-md bg-white shadow-lg ring-1 ring-gray-500 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div>
            <div className='w-full flex justify-start rounded pb-2 pl-2 '>
                <h1 className="p-2 font-semibold text-gray-900">
                    <span >Unternehmen wechseln</span>
                </h1>
            </div>
            {companies && companies.map((company, index) => {
                return (
                    <Menu.Item key={index}>
                        <button 
                        className={`flex p-2 hover:bg-gray-900 hover:text-white w-full cursor-pointer`} 
                        onClick={() => handleChange(company.target_id)}
                        >
                           {CompanyBadge(company.company_name, 9, 'xs', isCurrentCompany(company.target_id))}
                            <span className="h-8 p-2 flex-1 flex justify-start">{company.company_name}</span>
                            {isCurrentCompany(company.target_id) && <IoIosCheckmarkCircleOutline className="w-8 h-8 p-1 text-green-500 self-end" />} 
                        </button>
                    </Menu.Item>
                );
            })}
        </div>
      </Menu.Items>
    </Menu>
  );
}
